import { useEffect, useState } from "react";
import VideoIcon from "../../media/videoIcon.svg";
import HeartImage from "../../media/heartImage.svg";
import ArrowImage from "../../media/arrowImage.svg";
import AssetIcon from "../../media/assetIcon.svg";
// import "./ImageGallery.css";

export default function ImageGallery({ items = [], data,primaryColor = "#EFB33D" }) {
    console.log("items",items)
    const [active, setActive] = useState(items[0]);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
    }, [active]);

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;

        if (distance > 50) {
            // swipe left
            const next = (items.indexOf(active) + 1) % items.length;
            setActive(items[next]);
        }

        if (distance < -50) {
            // swipe right
            const prev =
            (items.indexOf(active) - 1 + items.length) % items.length;
            setActive(items[prev]);
        }
    };

    const noImage =
        `https://assets.diamondsoncall.com/assets/shapes/sample/No-image.svg`;

    const handleError = (e, item) => {
        const img = e.target;

        // prevent infinite loop
        if (!img.dataset.step) {
            img.dataset.step = "sample";

            // Step 2 → try sample
            if (item?.sample) {
            img.src = item.sample;
            return;
            }
        }

        if (img.dataset.step === "sample") {
            img.dataset.step = "noimage";

            // Step 3 → fallback to no image
            img.src = noImage;
        }
    };

    return (
        <div className="gallery">
            {/* THUMBS */}
            <div className="thumbs">
                {items.map((item, i) => (
                    <div
                        key={i}
                        className={`thumb ${active === item ? "active" : ""}`}
                        onClick={() => setActive(item)}
                        style={{borderColor:active === item ? primaryColor : ""}}
                    >
                        {item.name === "video" ? (
                            <img src={VideoIcon} alt="" style={{padding:8}} loading="lazy"/>
                        ) : item.name === "heart" ? (
                            <img src={HeartImage} alt="" style={{padding:8}} loading="lazy" />
                        ) : item.name === "arrow" ? (
                            <img src={ArrowImage} alt="" style={{padding:8}} loading="lazy" />
                        ) : item.name === "asset" ? (
                            <img src={AssetIcon} alt=""  style={{padding:8}} loading="lazy" />
                        ) : (
                            <img src={item?.src || item?.sample || noImage} alt="" onError={(e) => handleError(e, item)} loading="lazy" />
                        )}
                    </div>
                ))}
            </div>

            {/* MAIN */}
            <div 
                className="main"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >

                {loading && (
                    <div className="img-loader">
                        <div className="loader-spinner" style={{borderTopColor:primaryColor}} />
                    </div>
                )}
                
                {active?.type === "video" ? (
                    <div className="iframe-wrapper">
                        <iframe
                            src={active.src}
                            allowFullScreen
                            title="diamond-video"
                            frameBorder={"0"}
                            onLoad={() => setLoading(false)}
                        />
                    </div>
                ) : (
                    <img
                        src={active?.src || active?.sample || noImage} // 👈 initial fallback
                        alt=""
                        onLoad={() => setLoading(false)}
                        onError={(e) => {
                            handleError(e, active);
                            setLoading(false);
                        }}
                        style={{ opacity: loading ? 0 : 1 }}
                        loading="lazy"
                    />
                )}
            </div>
        </div>
    );
}
